import { APP_ROUTES } from '@/config/routes'
import { RouterView, type RouteRecordRaw } from 'vue-router'

// Tự động tìm tất cả các file .vue trong project
const viewModules = import.meta.glob(['@/pages/**/*.vue', '@/modules/**/*.views/*.vue', '@/modules/**/view/*.vue'])

/**
 * Cỗ máy sinh cấu hình Router tự động (Standardized & Automated)
 */
export const buildRouterConfig = (
  routesObject: any = APP_ROUTES,
  externalComponentMap: Record<string, any> = {}
): RouteRecordRaw[] => {
  const regular: RouteRecordRaw[] = []
  const catchAll: RouteRecordRaw[] = []

  const processNode = (node: any): RouteRecordRaw | null => {
    if (!node || typeof node !== 'object' || node.path === undefined || node.path === null) return null

    const name = node.name as string
    const route: RouteRecordRaw = {
      path: node.path,
      name: name,
      meta: node.meta || {}
    } as RouteRecordRaw

    // ─── Tự động hóa Component ───
    // 1. Phục vụ Map thủ công nếu cần ghi đè
    if (externalComponentMap[name]) {
      route.component = externalComponentMap[name]
    }
    // 2. Nếu đã khai báo component trong Route object (dạng path string)
    else if (node.component && typeof node.component === 'string') {
      const cleanPath = node.component.replace(/^(@\/|src\/|\/)/, '')
      const possiblePaths = [
        `/src/${cleanPath}`,
        `/src/${cleanPath}.vue`,
        `@/${cleanPath}`,
        `@/${cleanPath}.vue`
      ]

      let resolved = null
      for (const p of possiblePaths) {
        if (viewModules[p]) {
          resolved = viewModules[p]
          break
        }
      }
      route.component = resolved || RouterView // Fallback to RouterView if not found
    }
    // 3. Quy tắc "Cha" tự động nhận RouterView nếu có con mà chưa có component
    else if (node.children && Object.keys(node.children).length > 0) {
      route.component = RouterView
    }

    // Handle Redirect
    if (node.redirectTo) {
      route.redirect = { name: node.redirectTo }
    }

    // Handle Children (Recursive)
    if (node.children) {
      const children: RouteRecordRaw[] = []
      for (const key in node.children) {
        const childNode = processNode(node.children[key])
        if (childNode) children.push(childNode)
      }
      if (children.length > 0) {
        route.children = children
      }
    }

    return route
  }

  for (const key in routesObject) {
    const node = routesObject[key]
    const processed = processNode(node)

    if (processed) {
      if (node.type === 'catch-all') {
        catchAll.push(processed)
      } else {
        regular.push(processed)
      }
    }
  }

  return [...regular, ...catchAll]
}
